import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'

export const publicRoutes = [
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
    {
        key: 'register',
        path: `${AUTH_PREFIX_PATH}/register`,
        component: React.lazy(() => import('views/auth-views/authentication/register')),
    },
    {
        key: 'forgot-password',
        path: `${AUTH_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
    }
]

export const protectedRoutes = [
    {
        key: 'user_details.default',
        path: `${APP_PREFIX_PATH}/user_details/user_table`,
        component: React.lazy(() => import('views/app-views/user_details/user_table')),
    },
    {
        key: 'user_details:user_Post_table',
        path: `${APP_PREFIX_PATH}/user_details/user_Post_table`,
        component: React.lazy(() => import('views/app-views/user_details/user_post_table')),
    },
    {
        key: 'user_details:report_sentence',
        path: `${APP_PREFIX_PATH}/user_details/report_sentence`,
        component: React.lazy(() => import('views/app-views/user_details/report_sentence')),
    },
    {
        key: 'user_details:adduser',
        path: `${APP_PREFIX_PATH}/user_details/adduser`,
        component: React.lazy(() => import('views/app-views/user_details/adduser')),
    },
    {
        key: 'user_details:account_delete_sentence',
        path: `${APP_PREFIX_PATH}/user_details/account_delete_sentence`,
        component: React.lazy(() => import('views/app-views/user_details/account_delete_sentence')),
    },
    {
        key: 'user_details:account_band',
        path: `${APP_PREFIX_PATH}/user_details/account_band`,
        component: React.lazy(() => import('views/app-views/user_details/account_band')),
    },
    {
        key: 'user_details:delete_user_table',
        path: `${APP_PREFIX_PATH}/user_details/delete_user_table`,
        component: React.lazy(() => import('views/app-views/user_details/delete_user_table')),
    },
    {
        key: 'lands-landcategoies',
        path: `${APP_PREFIX_PATH}/lands/landcategoies`,
        component: React.lazy(() => import('views/app-views/lands/landcategoies')),
    },
    {
        key: 'lands-land_type',
        path: `${APP_PREFIX_PATH}/lands/land_type`,
        component: React.lazy(() => import('views/app-views/lands/land_type')),
    },
    {
        key: 'form_details-bhk_type',
        path: `${APP_PREFIX_PATH}/form_details/bhk_type`,
        component: React.lazy(() => import('views/app-views/form_details/bhk_type')),
    },
    {
        key: 'form_details-property_facing',
        path: `${APP_PREFIX_PATH}/form_details/property_facing`,
        component: React.lazy(() => import('views/app-views/form_details/property_facing')),
    },
    {
        key: 'form_details-other_rooms',
        path: `${APP_PREFIX_PATH}/form_details/other_rooms`,
        component: React.lazy(() => import('views/app-views/form_details/other_rooms')),
    },
    {
        key: 'form_details-FurnishingStatus',
        path: `${APP_PREFIX_PATH}/form_details/FurnishingStatus`,
        component: React.lazy(() => import('views/app-views/form_details/FurnishingStatus')),
    },
    {
        key: 'form_details-Amenities',
        path: `${APP_PREFIX_PATH}/form_details/Amenities`,
        component: React.lazy(() => import('views/app-views/form_details/Amenities')),
    },
    {
        key: 'form_details-PropertyHighlights',
        path: `${APP_PREFIX_PATH}/form_details/PropertyHighlights`,
        component: React.lazy(() => import('views/app-views/form_details/PropertyHighlights')),
    },
    {
        key: 'form_details-reception_area',
        path: `${APP_PREFIX_PATH}/form_details/reception_area`,
        component: React.lazy(() => import('views/app-views/form_details/reception_area')),
    },
    {
        key: 'form_details-oxygen_duct',
        path: `${APP_PREFIX_PATH}/form_details/oxygen_duct`,
        component: React.lazy(() => import('views/app-views/form_details/oxygen_duct')),
    },
    {
        key: 'form_details-Lifts',
        path: `${APP_PREFIX_PATH}/form_details/Lifts`,
        component: React.lazy(() => import('views/app-views/form_details/Lifts')),
    },
    {
        key: 'form_details-UPS',
        path: `${APP_PREFIX_PATH}/form_details/UPS`,
        component: React.lazy(() => import('views/app-views/form_details/UPS')),
    },
    {
        key: 'form_details-FireSafetyMeasures',
        path: `${APP_PREFIX_PATH}/form_details/FireSafetyMeasures`,
        component: React.lazy(() => import('views/app-views/form_details/FireSafetyMeasures')),
    },
    {
        key: 'form_details-WashroomDetails',
        path: `${APP_PREFIX_PATH}/form_details/WashroomDetails`,
        component: React.lazy(() => import('views/app-views/form_details/WashroomDetails')),
    }
]